var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 487.38 487.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m 160.38358,218.03606 c 0,0 -17.17727,-9.67534 7.71007,-74.49341 -56.68609,59.16295 -36.07172,88.4497 -38.95481,126.79977 0,0 -6.15447,8.66146 -10.423,-62.06812 -35.678134,62.79176 -48.744827,70.67758 -28.036887,138.85064 -30.146182,44.00753 -28.876611,36.89564 -59.103636,100.95402 -4.40619,9.33779 0.05373,11.78908 6.182556,10.88403 C 91.794363,354.37141 453.52831,44.228441 453.52831,44.228441 c 0,0 -243.89574,-120.843284 -293.14473,173.807619 z",
    id: "path2",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 116.33381,368.95642 C 281.52018,298.19388 495.63051,84.57759 458.13018,51.177943 c 0,0 -256.39773,224.131087 -341.79637,317.778477 z",
    id: "path2-3",
    style: {
      fill: "#202020"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditor);
export default __webpack_public_path__ + "static/media/editor.4553a2a4.svg";
export { ForwardRef as ReactComponent };